// extracted by mini-css-extract-plugin
module.exports = {"container":"About-module--container--1InMZ","leftContainer":"About-module--leftContainer--2yLZ7","sidebarLink":"About-module--sidebarLink--1yo-c"};